import { render, staticRenderFns } from "./EvatSubmitAction.vue?vue&type=template&id=9c85fb52&scoped=true"
import script from "./EvatSubmitAction.vue?vue&type=script&lang=js"
export * from "./EvatSubmitAction.vue?vue&type=script&lang=js"
import style0 from "./EvatSubmitAction.vue?vue&type=style&index=0&id=9c85fb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c85fb52",
  null
  
)

export default component.exports